import React from 'react';
import clsx from 'clsx';
import { Button } from '@randompedestrian07/ui';
import { ToggleLeft, ToggleRight, Trash2 } from 'lucide-react';

interface EntityListItemProps {
    avatarUrl: string;
    avatarFallback?: string;
    name: string;
    subtitle?: string;
    subtitleIcon?: React.ReactNode;
    isEnabled?: boolean;
    metadata?: React.ReactNode;
    onToggle?: () => void;
    onDelete?: () => void;
    onClick?: () => void;
    disabled?: boolean;
    className?: string;
}

export const EntityListItem: React.FC<EntityListItemProps> = ({
    avatarUrl,
    name,
    subtitle,
    subtitleIcon,
    isEnabled,
    metadata,
    onToggle,
    onDelete,
    onClick,
    disabled = false,
    className,
}) => {
    return (
        <div
            onClick={onClick}
            className={clsx(
                "group/record p-4 rounded-3xl bg-panel-strong/20 border border-stroke/40 flex items-center justify-between transition-all",
                onClick && "hover:bg-panel-strong/40 hover:border-accent/20 hover:shadow-2xl hover:shadow-accent/5 cursor-pointer",
                className
            )}
        >
            <div className="flex items-center gap-4 flex-1 min-w-0">
                <div className="relative flex-shrink-0">
                    <img
                        src={avatarUrl}
                        alt=""
                        className="w-12 h-12 rounded-2xl object-cover shadow-lg border-2 border-stroke/40"
                    />
                    {isEnabled !== undefined && (
                        <div
                            className={clsx(
                                "absolute -bottom-1 -right-1 w-4 h-4 rounded-full border-2 border-bg-solid shadow-sm",
                                isEnabled ? "bg-green" : "bg-muted"
                            )}
                        />
                    )}
                </div>
                <div className="overflow-hidden min-w-0">
                    <div className="font-bold text-text truncate pr-4">{name}</div>
                    {subtitle && (
                        <div className="text-[10px] font-bold text-muted/40 uppercase tracking-widest flex items-center gap-2 truncate">
                            {subtitleIcon}
                            {subtitle}
                        </div>
                    )}
                </div>
            </div>

            <div className="flex items-center gap-6 flex-shrink-0">
                {metadata}
                {(onToggle || onDelete) && (
                    <div className="flex items-center gap-2" onClick={e => e.stopPropagation()}>
                        {onToggle && (
                            <Button
                                variant="ghost"
                                size="icon"
                                className="h-10 w-10 rounded-xl text-muted hover:text-accent hover:bg-accent/10"
                                onClick={onToggle}
                                disabled={disabled}
                            >
                                {isEnabled ? <ToggleRight size={22} /> : <ToggleLeft size={22} />}
                            </Button>
                        )}
                        {onDelete && (
                            <Button
                                variant="ghost"
                                size="icon"
                                className="h-10 w-10 rounded-xl text-muted hover:text-red hover:bg-red/10"
                                onClick={onDelete}
                                disabled={disabled}
                            >
                                <Trash2 size={20} />
                            </Button>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};
